import React from "react";
import { CarrierName } from "../ShippingPreferencesSection";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Select, SelectProps, Table, Tooltip } from "antd";

interface ShippingPreferencesTableProps {
  selectChange: (selectedValue: string, carrierName: string) => void;
  removePreference: (carrierName: CarrierName) => void;
  dataSource: CarrierName[];
  whitelisted: string[];
  blacklisted: string[];
}

const ShippingPreferencesTable: React.FC<ShippingPreferencesTableProps> = ({
  selectChange,
  removePreference,
  whitelisted,
  blacklisted,
  dataSource,
}) => {
  const buildColumns = () => {
    return [
      {
        title: "Carrier Name",
        key: "carrier_name",
        render: (_: string, carrierName: CarrierName) => <>{carrierName.carrierName}</>,
        width: "33%",
      },
      {
        title: () => (
          <>
            Preference{" "}
            <Tooltip placement="right" title={"Select carriers the merchant prefers to work with or to exclude"}>
              <ExclamationCircleOutlined style={{ color: "#4a90e2" }} />
            </Tooltip>
          </>
        ),
        key: "preference",
        width: "33%",
        render: renderPreferenceSelect,
      },
      {
        title: "",
        key: "remove",
        width: "33%",
        render: renderPreferenceDelete,
      },
    ];
  };
  const renderPreferenceSelect = (_: string, carrierName: CarrierName) => {
    let status = "Prefer";
    if (whitelisted.includes(carrierName.carrierName)) {
      status = "Prefer";
    } else if (blacklisted.includes(carrierName.carrierName)) {
      status = "Exclude";
    }

    const options: SelectProps<string>["options"] = [
      {
        value: "Prefer",
        label: "Prefer",
      },
      {
        value: "Exclude",
        label: "Exclude",
      },
    ];

    return (
      <Select
        onChange={(selectedValue) => {
          selectChange(selectedValue, carrierName.carrierName);
        }}
        defaultValue={status}
        style={{ width: "75%" }}
        options={options}
      ></Select>
    );
  };
  const renderPreferenceDelete = (carrierName: CarrierName) => {
    return (
      <Button danger={true} onClick={() => removePreference(carrierName)} type="text">
        <DeleteOutlined />
        Remove Preference
      </Button>
    );
  };
  return <Table dataSource={dataSource} columns={buildColumns()} pagination={false} />;
};

export default ShippingPreferencesTable;
